import { call, put, select } from 'redux-saga/effects'
import { selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import { callApi } from '@/shared/tools/apiSagaHelper'
import {
  selectActiveAddress,
  selectConfig,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateElectricityMeterAddressData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { saveMeterShared } from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSaveSharedSagas'
import * as Sentry from '@sentry/react'

export const electricityMeterModuleActions = {
  METER_MODULE_CHECK_DUPLICATED_PDL_V2: 'METER_MODULE_CHECK_DUPLICATED_PDL_V2',
  METER_MODULE_REQUEST_PDL_DATA_V2: 'METER_MODULE_REQUEST_PDL_DATA_V2',
  METER_MODULE_VALIDATE_PDL_METER_SYNTAX_V2: 'METER_MODULE_VALIDATE_PDL_METER_SYNTAX_V2',
  SAVE_ELECTRICITY_METER_V2: 'SAVE_ELECTRICITY_METER_V2',
  PDL_SEARCH_V2: 'PDL_SEARCH_V2',
}

export function* checkDuplicatedPdlMeter({ meterId, energyType, duplicatedCallback }) {
  const { podValidateDuplicatedUrl } = yield select(selectExtraRoutesAuthData)
  const { contactId } = yield select(selectConfig)
  const fullUrl = `${podValidateDuplicatedUrl}?meterId=${meterId}&energyType=${energyType}`

  try {
    const data = yield call(callApi, {
      endpoint: fullUrl,
      asteriskReplacement: contactId,
      showErrorSnackbar: false,
    })

    yield call(duplicatedCallback, data)
  } catch (error) {
    yield call(duplicatedCallback, null)
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('checkDuplicatedMeterError'), { extra: { error } })
    }
  }
}

export function* requestPdlMeterData({ body }) {
  const { podEligibilityUrl } = yield select(selectExtraRoutesAuthData)
  const activeAddress = yield select(selectActiveAddress)

  try {
    yield put(
      updateElectricityMeterAddressData({
        data: {
          pdlEligibilityLoading: true,
          pdlEligibilityData: {},
        },
        id: activeAddress,
      }),
    )
    yield call(callApi, {
      endpoint: podEligibilityUrl,
      showErrorSnackbar: false,
      payload: body,
      method: 'POST',
    })
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('requestMeterDataError'), { extra: { error } })
    }
  }
}

export function* validatePdlMeterSyntax({ meterId, callback }) {
  const { podValidateUrl } = yield select(selectExtraRoutesAuthData)
  const fullUrl = `${podValidateUrl}?meterId=${meterId}`
  try {
    const data = yield call(callApi, {
      endpoint: fullUrl,
      showErrorSnackbar: false,
    })
    yield call(callback, data)
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('validateMeterSyntaxError'), { extra: { error } })
    }
  }
}

export function* saveElectricityMeter({ enqueue, meterData, addressId }) {
  return yield call(saveMeterShared, {
    enqueue,
    meterData,
    addressId,
    meterType: 'electricity',
  })
}

export function* searchPdl({ searchParams, onSuccess, onError }) {
  const { podSearchUrl } = yield select(selectExtraRoutesAuthData)

  try {
    const params = new URLSearchParams({
      lookup_street_name: searchParams.streetName || '',
      zipcode: searchParams.zipcode || '',
      clientType: searchParams.contractType || 'part',
      pod_old_occupant: searchParams.occupant || '',
      matricule: searchParams.matricule || '',
      inseeCode: searchParams.inseeCode || '',
      apartment_complement: searchParams.complement || '',
      building: searchParams.building || '',
      locality: searchParams.locality || '',
      podType: 'PDL',
    })

    const fullUrl = `${podSearchUrl}?${params.toString()}`

    const response = yield call(callApi, {
      endpoint: fullUrl,
      showErrorSnackbar: false,
    })

    if (response.response) {
      yield call(onSuccess, response.response)
      return
    }

    if (response.error_message) {
      yield call(onError, response.error_message)
      return
    }

    if (response.id) {
      yield call(onSuccess, [], response.id)
    }
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('searchPdlError'), { extra: { error } })
    }
    yield call(onError, 'An error occurred while searching for PDL data')
  }
}
